/**
 * ブラウザに表示されたかどうかを検知する
 */
import emergence from "emergence.js"

export default function() {
  emergence.init({
    container: window,
    reset: false,
    handheld: true,
    throttle: 250,
    elemCushion: 0.15,
    callback: function(element, state) {
    //   if (state === 'visible') {
    //   } else if (state === 'reset') {
    //   } else if (state === 'noreset') {
    //   }
    }
  });
};